/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getRadius, getSpacing } from './types';
/**
 * Box is a general-purpose container that allows for controlled use of design tokens.
 * Use the given props to configure display behavior and styling that aligns with Needle's tokens.
 */
export const Box = forwardRef(function Box({ as = 'div', padding, paddingInline, paddingInlineStart, paddingInlineEnd, paddingBlockEnd, paddingBlockStart, borderRadius, children, style, htmlAttributes, }, ref) {
    const Component = as || 'div';
    const additionalStyle = {
        padding: getSpacing(padding, 'padding'),
        paddingInline: getSpacing(paddingInline, 'paddingInline'),
        paddingInlineStart: getSpacing(paddingInlineStart, 'paddingInlineStart'),
        paddingInlineEnd: getSpacing(paddingInlineEnd, 'paddingInlineEnd'),
        paddingBlockEnd: getSpacing(paddingBlockEnd, 'paddingBlockEnd'),
        paddingBlockStart: getSpacing(paddingBlockStart, 'paddingBlockStart'),
        borderRadius: getRadius(borderRadius, 'borderRadius'),
    };
    return (_jsx(Component, Object.assign({ ref: ref, style: Object.assign(Object.assign({}, additionalStyle), style) }, htmlAttributes, { children: children })));
});
//# sourceMappingURL=Box.js.map